/**
 * Configuration globale de l'application
 */

// URL de base de l'API - configurée via les variables d'environnement
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

// API Key pour l'authentification
export const API_KEY = '123';

// URL de base pour les endpoints "OLD" (anciennement n8n, maintenant migrés vers admin.hlwc.fr)
// Les noms de paths sont conservés pour compat — voir app/public_api.py côté backend.
export const N8N_API_BASE_URL = 'https://admin.hlwc.fr/public';

// Configuration du mode de transition
// IMPORTANT: les endpoints "OLD_API" sont les anciens formats n8n, mais ils pointent
// maintenant vers admin.hlwc.fr/public (VPS). Les endpoints "NEW_API" étaient ceux de
// l'ancien backend Vercel (/api/tenant?...api_key=123) et ne doivent plus être utilisés.
export const API_CONFIG = {
  FINANCIAL_REPORT_USES_NEW_API: false,
  OTHERS_USE_NEW_API: false
};

// Endpoints API
export const API_ENDPOINTS = {
  // Endpoints de la nouvelle API
  NEW_API: {
    BASE: `${API_BASE_URL}/api`,
    FINANCIAL_REPORT: (tenantId) => `${API_BASE_URL}/api/tenant/${tenantId}/financial-report?api_key=123`,
    UPDATE_NOTE: `${API_BASE_URL}/api/note`,
    UPDATE_CLOTURE: `${API_BASE_URL}/api/cloture-status`,
    GENERATE_RECEIPTS: `${API_BASE_URL}/api/generate-receipts`,
    UPDATE_INVOICE_VERSION: `${API_BASE_URL}/api/update-invoice-version`,
    DELETE_INVOICE: (invoiceId) => `${API_BASE_URL}/api/invoice/${invoiceId}`,
    TRANSACTION: `${API_BASE_URL}/api/transaction`,
    UPDATE_BAIL: `${API_BASE_URL}/api/update-bail`
  },
  
  // Endpoints de l'ancienne API
  OLD_API: {
    BASE: N8N_API_BASE_URL,
    FINANCIAL_REPORT: (tenantId) => `${N8N_API_BASE_URL}/tenant/${tenantId}/financial-report`,
    UPDATE_NOTE: `${N8N_API_BASE_URL}/add-note-to-record`,
    UPDATE_CLOTURE: `${N8N_API_BASE_URL}/add-note-to-record`,
    GENERATE_RECEIPTS: (bailID) => `${N8N_API_BASE_URL}/quittances/locataire?record_id=${bailID}`,
    UPDATE_INVOICE_VERSION: `${N8N_API_BASE_URL}/update-facture`,
    DELETE_INVOICE: {
      STANDARD: (invoiceId) => `${N8N_API_BASE_URL}/delete-facture?id=${invoiceId}`,
      V2: (invoiceId) => `${N8N_API_BASE_URL}/delete-facture-v2?id=${invoiceId}`
    },
    UPDATE_BAIL: `${N8N_API_BASE_URL}/update-bail`
  }
};

// Création d'une API hybride pour la phase de transition
// ASTUCE: Nous gardons les deux structures (NEW et OLD) pour faciliter l'adaptation du code au format requis
export const TRANSITION_API = {
  /* API ENDPOINTS */
  // Utilise la nouvelle API pour financial report
  FINANCIAL_REPORT: API_CONFIG.FINANCIAL_REPORT_USES_NEW_API 
    ? API_ENDPOINTS.NEW_API.FINANCIAL_REPORT 
    : API_ENDPOINTS.OLD_API.FINANCIAL_REPORT,
  
  // Utilise l'ancienne API pour les autres endpoints
  UPDATE_NOTE: API_CONFIG.OTHERS_USE_NEW_API 
    ? API_ENDPOINTS.NEW_API.UPDATE_NOTE 
    : API_ENDPOINTS.OLD_API.UPDATE_NOTE,
    
  UPDATE_CLOTURE: API_CONFIG.OTHERS_USE_NEW_API 
    ? API_ENDPOINTS.NEW_API.UPDATE_CLOTURE 
    : API_ENDPOINTS.OLD_API.UPDATE_CLOTURE,
    
  GENERATE_RECEIPTS: API_CONFIG.OTHERS_USE_NEW_API 
    ? API_ENDPOINTS.NEW_API.GENERATE_RECEIPTS 
    : API_ENDPOINTS.OLD_API.GENERATE_RECEIPTS,
    
  UPDATE_INVOICE_VERSION: API_CONFIG.OTHERS_USE_NEW_API 
    ? API_ENDPOINTS.NEW_API.UPDATE_INVOICE_VERSION 
    : API_ENDPOINTS.OLD_API.UPDATE_INVOICE_VERSION,
    
  DELETE_INVOICE: API_CONFIG.OTHERS_USE_NEW_API 
    ? API_ENDPOINTS.NEW_API.DELETE_INVOICE 
    : API_ENDPOINTS.OLD_API.DELETE_INVOICE,
    
  TRANSACTION: API_CONFIG.OTHERS_USE_NEW_API 
    ? API_ENDPOINTS.NEW_API.TRANSACTION 
    : API_ENDPOINTS.OLD_API.TRANSACTION,
    
  UPDATE_BAIL: API_CONFIG.OTHERS_USE_NEW_API 
    ? API_ENDPOINTS.NEW_API.UPDATE_BAIL 
    : API_ENDPOINTS.OLD_API.UPDATE_BAIL,
  
  /* FORMAT FLAGS */
  // Indique pour chaque endpoint le format de données à utiliser (true = nouveau format, false = ancien format)
  formats: {
    UPDATE_NOTE_USES_NEW_FORMAT: false,
    UPDATE_CLOTURE_USES_NEW_FORMAT: false,
    GENERATE_RECEIPTS_USES_NEW_FORMAT: false,
    UPDATE_INVOICE_VERSION_USES_NEW_FORMAT: false,
    DELETE_INVOICE_USES_NEW_FORMAT: false,
    UPDATE_BAIL_USES_NEW_FORMAT: false
  }
};

// API active à utiliser
export const ACTIVE_API = TRANSITION_API;

export default {
  API_BASE_URL,
  API_CONFIG,
  API_ENDPOINTS,
  ACTIVE_API
};
